import { styled } from '../../styled';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledHeadingContainer = styled.div`
  text-align: center;
`;

export const StyledAddressInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const StyledRow = styled.div`
  width: 100%;
  margin: 8px 0 4px;
  display: flex;
  justify-content: space-between;
`;

export const StyledPropertyTypeContainer = styled.div`
  width: 100%;
`;

export const StyledUnitInputContainer = styled.div`
  width: 30%;
  max-width: 210px;
  margin-left: 24px;
`;

export const StyledSharedPropertyContainer = styled.div`
  width: 100%;
  min-height: 30px;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
